import React from "react";
import { Link } from "@quintype/components";
import "./follow-us.m.css";

import Whatsapp from "../../../atoms/social-media-icons/Whatsapp";
import { STATIC_KEYWORDS } from "../../../../constants";

function FollowUs() {
  const whatsapp_url =
    "https://www.whatsapp.com/channel/0029Va4ifN6AYlULZASc7V3S";

  return (
    <div styleName="wrapper">
      <Link
        styleName="icon-wrapper"
        href={whatsapp_url}
        target="_blank"
      >
        <Whatsapp width="20" height="20" color="#25D366" />
        <span styleName="join-us-text">
          {STATIC_KEYWORDS.JOIN_US}
        </span>
      </Link>
    </div>
  );
}

export default FollowUs;
